// -----------------------
// Product Customizations
// -----------------------

// DOM Ready
function documentReady(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

const cr = {
    variantsSelected: function(type){
        let variantSelectors;
        if (type === 'radio'){
            variantSelectors = document.querySelector('variant-radios');
            const fieldsets = variantSelectors.querySelectorAll('fieldset');
            let values = [];
            fieldsets.forEach(fieldset => {
                const inputs = fieldset.querySelectorAll('input');
                inputs.forEach(input => {
                    if (input.checked){
                        values.push(input.getAttribute('value'));
                    }

                });
            });
            return values;
        }
        if (type === 'select'){
            variantSelectors = document.querySelectorAll('variant-selects select');
            let values = [];
            variantSelectors.forEach(select => {
                const selectedOption = select.options[select.selectedIndex];
                values.push(selectedOption.value);
            });
            return values;
        }

    },
    updateSelectedPrice: function(variantsSelected){
        const compareAtPrice = parseInt(cr.matchingVariant(variants, variantsSelected).compare_at_price);
        let regularPrice = parseInt(cr.matchingVariant(variants, variantsSelected).price);
        const priceSaleElement = document.querySelector('.price__sale');
        const salePriceElement = priceSaleElement.querySelector('.price-item--sale');
        const compareElement = priceSaleElement.querySelector('s.price-item--regular');

        compareElement.innerHTML = '$' + compareAtPrice / 100;
        salePriceElement.innerHTML = '$' + regularPrice / 100;
    },
    variantsOnChange: function(type){
        let selectors;
        if (type === 'radio'){
            selectors = document.querySelectorAll('.product-form__input input[type="radio"]');
        }
        if (type === 'select'){
            selectors = document.querySelectorAll('.product-form__input select');
        }
        selectors.forEach(selector => {
            selector.addEventListener('change', event => {
                // Update Product Photo
                cr.updateProductPhoto(cr.matchingVariant(variants, cr.variantsSelected(type)).featured_media.preview_image.src);
                document.querySelector('input.product-variant-id').value = cr.matchingVariant(variants, cr.variantsSelected(type)).id;
                cr.updateSelectedPrice(cr.variantsSelected(type));
            });
        });
    },
    matchingVariant: function(variants, variantsSelected) {
        return variants.find(variant => {
            return variant.options.every((option, index) => {
                return option === variantsSelected[index];
            });
        });
    },
    updateProductPhoto: function(imageUrl){
        // Find slide with matching src
        const slickSlides = document.querySelectorAll('.slick-slide');
        slickSlides.forEach(slide => {
            const img = slide.querySelector('img');
            if (img) {
                const imgSrc = img.getAttribute('src');
                const protocolRemovedSrc = imageUrl.replace('https:', '');
                if (imgSrc === protocolRemovedSrc) {
                    let slideIndex = slide.getAttribute('data-slick-index');
                    // Use slickGoTo to go to that slide
                    $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', slideIndex);
                }
            }
        });
    },
    quantityChange: function(){
        const minButton = document.querySelector('.quantity-form .min');
        const plusButton = document.querySelector('.quantity-form .plus');
        const quantityInput = document.getElementById('Quantity');

        if(minButton) {
            minButton.addEventListener('click', event => {
                event.preventDefault();
                let quantity = parseInt(quantityInput.value);
                if (quantity > 1) {
                    quantity--;
                    quantityInput.value = quantity;
                }
            });
        }
        
        if(plusButton) {
            plusButton.addEventListener('click', event => {
                event.preventDefault();
                let quantity = parseInt(quantityInput.value);
                quantity++;
                quantityInput.value = quantity;
            });
        }
        
    }
}

// Page is Ready
documentReady(function() {
    // Variant Radios
    if ( document.querySelector('variant-radios') !== null ){
        // Detect changes to radio buttons
        cr.variantsOnChange('radio');
    }

    // Variant Selects
    if ( document.querySelector('variant-selects') !== null ){
        // Detect changes to select elements
        cr.variantsOnChange('select');
    }

    // Quantity Change
    cr.quantityChange();

});
